export default "__VITE_ASSET__Dcg8gXEV__"